import * as React from 'react'

export type TUserListener = null | (() => void)

export interface IUserListenerContext {
  userListener: TUserListener
  setUserListener: React.Dispatch<React.SetStateAction<TUserListener>>
}

export const UserListenerContext = React.createContext<IUserListenerContext>({
  userListener: null,
  setUserListener: () => {
    return
  }
})



// WEBPACK FOOTER //
// ./src/components/UserListener/context.ts